import { EventCategoryAdapter, Resources } from "@validereinc/domain";
import { useGetList, useGetOne } from "./adapterUtils";

export const useGetOneEventCategory = useGetOne(
  EventCategoryAdapter.getOne,
  Resources.EVENT_CATEGORY
);

export const useListEventCategories = useGetList(
  EventCategoryAdapter.getList,
  Resources.EVENT_CATEGORY
);
